export default "__VITE_ASSET__BrNb_D0k__"